<template>
  <b-navbar
    type="light"
    toggleable="xl"
    fixed="top"
    v-b-scrollspy:nav-scroller
    class="header-area"
    :class="{ 'is-sticky': scrolled }"
  >
    <div class="container-fluid container-fluid--cp-150">
      <b-navbar-toggle target="nav_collapse"></b-navbar-toggle>
      <b-navbar-brand class="navbar-brand" to="/">
        <img
          src="/logo-2.png"
          alt="logo"
          style="height: 2.8rem; width: auto; margin: -4px 0.1rem 0; border-radius:6px"
        />
        <span
          style="color: #2e3280;
                  font-family: Rubik, Helvetica, Arial, sans-serif;
                  font-weight: 500;
                  font-size:1.35rem;"
          class="ml-2"
          >Sandrasoft</span
        >
      </b-navbar-brand>
      <b-btn-group class="header-config-wrapper">
        <!-- <b-link
          href="https://his.sandrasoft.app"
          class="ht-btn ht-btn--outline hire-btn d-none d-xl-block"
        >
          Using The App
        </b-link> -->
        <button
          @click="useTheApp"
          type="submit"
          class="ht-btn ht-btn-lg mr-3"
          style="
            color: white;
            border-color: white;
            border-width: 2px;
            width: 240px;
            line-height: 56px;
          "
        >
          Start Using the App
        </button>
      </b-btn-group>
      <b-collapse
        class="default-nav justify-content-center"
        is-nav
        id="nav_collapse"
      >
        <b-navbar-nav class="navbar-nav main-menu">
          <b-nav-item @click="redirect('/#home')" class="scroll">
            <span>HOME</span>
          </b-nav-item>
          <b-nav-item @click="redirect('/#mission')" class="scroll">
            <span>MISSION</span>
          </b-nav-item>
          <b-nav-item @click="redirect('/#service')" class="scroll">
            <span>SERVICE</span>
          </b-nav-item>
          <b-nav-item @click="redirect('/#pricing')" class="scroll">
            <span>PRICING</span>
          </b-nav-item>
          <b-nav-item @click="redirect('/#contact')" class="scroll">
            <span>CONTACT</span>
          </b-nav-item>
          <b-nav-item @click="redirect('/blogs')" class="scroll">
            <span>ARTICLES</span>
          </b-nav-item>
          <b-nav-item @click="useTheApp" class="scroll">
            <span>LOGIN</span>
          </b-nav-item>
        </b-navbar-nav>
      </b-collapse>
    </div>
  </b-navbar>
</template>

<script>
export default {
  data() {
    return {
      load: false,
      limitPosition: 200,
      scrolled: false,
      lastPosition: 500,
    };
  },
  mounted() {
    (function() {
      scrollTo();
    })();

    function scrollTo() {
      const links = document.querySelectorAll(".scroll > a");
      links.forEach((each) => (each.onclick = scrollAnchors));
    }

    function scrollAnchors(e, respond = null) {
      const distanceToTop = (el) => Math.floor(el.getBoundingClientRect().top);
      e.preventDefault();
      var targetID = respond
        ? respond.getAttribute("href")
        : this.getAttribute("href");
      const targetAnchor = document.querySelector(targetID);
      if (!targetAnchor) return;
      const originalTop = distanceToTop(targetAnchor);
      window.scrollBy({ top: originalTop, left: 0, behavior: "smooth" });
      const checkIfDone = setInterval(function() {
        const atBottom =
          window.innerHeight + window.pageYOffset >=
          document.body.offsetHeight - 190;
        if (distanceToTop(targetAnchor) === 0 || atBottom) {
          targetAnchor.tabIndex = "-1";
          targetAnchor.focus();
          clearInterval(checkIfDone);
        }
      }, 800);
    }
  },
  methods: {
    // sticky menu script
    useTheApp() {
      window.open("https://his.sandrasoft.app");
    },
    handleScroll() {
      if (
        this.lastPosition < window.scrollY &&
        this.limitPosition < window.scrollY
      ) {
        this.scrolled = true;
        // move up!
      }
      if (this.lastPosition > window.scrollY) {
        this.scrolled = true;
        // move down
      }
      this.lastPosition = window.scrollY;
      this.scrolled = window.scrollY > 50;
    },

    // offcanvas searchbox
    toggleClass(addRemoveClass, className) {
      const el = document.querySelector("#search-overlay");
      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
  },
  created() {
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
};
</script>

<style scoped>
.is-sticky {
  box-shadow: none;
  border-bottom: 4px solid rgb(108, 103, 233);
}
</style>
